// src/api/api.js
import axios from "axios";
import { toast } from "react-toastify";


// testing
// export const API_BASE_PATH_ADMIN = "http://localhost:4200/admin"; //BASE_URL_MAIN
// export const API_BASE_PATH_USER = "http://localhost:4200/user";
// export const API_BASE_PATH_USER_LOGIN = "http://localhost:3001/dashboard";
// export const SOCKET_SERVER_URL_WSS = "wss://localhost:4200";
// live
export const API_BASE_PATH_ADMIN = "https://apis.aethrx.pro/admin"; //BASE_URL_MAIN
export const API_BASE_PATH_USER = "https://apis.aethrx.pro/user";
export const API_BASE_PATH_USER_LOGIN = "https://user.aethrx.pro/dashboard";
export const SOCKET_SERVER_URL_WSS = "wss://apis.aethrx.pro";

/** Base URL for ROI closing GET routes. Defaults to admin API; set REACT_APP_CLOSING_API_BASE to your API origin if those routes are not under /admin (e.g. https://apis.alpindigital.com). */
export const API_CLOSING_PREFIX =
  (typeof process !== "undefined" && process.env.REACT_APP_CLOSING_API_BASE) ||
  API_BASE_PATH_ADMIN;

//Testing APIs
// export const API_BASE_PATH_ADMIN = 'https://apisorigincapital.eracom.in/admin';     //BASE_URL_TESTING
// export const API_BASE_PATH_USER = 'https://apisorigincapital.eracom.in/user';
// export const API_BASE_PATH_USER_LOGIN = 'https://userorigincapital.eracom.in/dashboard';
// export const SOCKET_SERVER_URL_WSS = 'wss://apisorigincapital.eracom.in'

//Testing APIs
// export const API_BASE_PATH_ADMIN = 'http://94.136.186.193:9798/admin';     //BASE_URL_TESTING
// export const API_BASE_PATH_USER = 'http://94.136.186.193:9897/user';
// export const API_BASE_PATH_USER_LOGIN = 'http://94.136.186.193:9897/dashboard';
// export const SOCKET_SERVER_URL_WSS = 'wss://94.136.186.193:9897'

const apiCall = async (
  method,
  endpoint,
  data = null,
  showToast = false,
  baseUrl = API_BASE_PATH_ADMIN
) => {
  const Authorization = localStorage.getItem("authToken");

  let headers = {
    Authorization,
  };

  const m = String(method).toLowerCase();
  // Only set 'Content-Type' to 'application/json' if not sending FormData (skip on GET — some servers reject it)
  if (!(data instanceof FormData) && m !== "get" && m !== "head") {
    headers["Content-Type"] = "application/json";
  }

  try {
    const response = await axios({
      method: method,
      url: `${baseUrl}${endpoint}`,
      data: data,
      headers: headers,
    });
    console.log(endpoint, response.data);
    showToast && toast.success(response.data.message || "Request success");
    return { data: response.data, error: null };
  } catch (error) {
    console.log(endpoint, error);
    let code = 0;
    let errorMessage = "An unexpected error occurred";

    if (error.response) {
      const body = error.response.data;
      errorMessage =
        (typeof body === "object" && body?.message) ||
        (typeof body === "string" && body) ||
        error.response.statusText;
      code = (typeof body === "object" && body?.code) || 0;
    } else if (error.request) {
      errorMessage = "No response from server. Please try again later.";
    } else {
      errorMessage = error.message;
    }

    showToast && toast.error(errorMessage || "Request failed"); // Show error message using toast
    return { data: null, error: { code, message: errorMessage } };
  }
};

export default apiCall;
